export default __webpack_public_path__ + "static/media/Inventory-empty-state-icon.7fe8238b.svg";